import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  monitorResults,
  testResults
} from '../../docs-routes'
import {
  useConfigTypeTitle,
  useModule
} from '@eggplant/routing'

const LinkToTestResultsDoc = () => {
  const [isMonitorFlag] = useModule()
  const configTypeTitle = useConfigTypeTitle(true)

  const pathToDoc = isMonitorFlag
    ? monitorResults
    : testResults

  return (
    <LinkToDocusaurus path={pathToDoc}>
      Learn more about {configTypeTitle} Results
    </LinkToDocusaurus>
  )
}

export default LinkToTestResultsDoc
